import { Component, Input } from '@angular/core';
import { Szme037aResponseCdtmnySyosaiRefInfDto } from 'sg-api';
import { DateDurationPipe } from '../../../../../sg-kd-shared/pipes/date-duration.pipe';

/**
 * 売掛金詳細
 *
 * @export
 * @class UrikakekinGasDetailComponent
 */

@Component({
  selector: 'app-urikakekin-gas-detail',
  templateUrl: './urikakekin-gas-detail.component.html',
  styleUrls: ['./urikakekin-gas-detail.component.scss'],
  providers: [DateDurationPipe]
})
export class UrikakekinGasDetailComponent {
  @Input() urikakekinInfo: Szme037aResponseCdtmnySyosaiRefInfDto;
  @Input() fixedInfo: string;
  @Input() prdClsfyDiv: string; 

  /** 画面表示項目 */
  displayedColumns: string[] = [
    'detailHyojiAname',
    'chargeCodeMny'
  ];

  constructor() { }

}
